/* Swiss Watches Dot Com – FAQ page: client-side search with highlighting,
   deep links (#question-slug) and a scroll-spy category nav. No dependencies. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sw-faq]');
  if (!root) return;

  var input = root.querySelector('[data-sw-faq-search]');
  var form = root.querySelector('[data-sw-faq-form]');
  var clearButton = root.querySelector('[data-sw-faq-clear]');
  var countEl = root.querySelector('[data-sw-faq-count]');
  var emptyEl = root.querySelector('[data-sw-faq-empty]');
  var termEl = root.querySelector('[data-sw-faq-term]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sw-faq-group]'));
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-sw-faq-item]'));
  var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-sw-faq-nav-link]'));

  /* Keep pristine markup so highlights can be removed cleanly. */
  var records = items.map(function (item) {
    var question = item.querySelector('.sw-faq__q-text') || item.querySelector('.sw-faq__q');
    var answer = item.querySelector('.sw-faq__a');
    return {
      el: item,
      question: question,
      answer: answer,
      questionHTML: question ? question.innerHTML : '',
      answerHTML: answer ? answer.innerHTML : '',
      text: ((question ? question.textContent : '') + ' ' + (answer ? answer.textContent : '')).toLowerCase()
    };
  });

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlightNode(node, pattern) {
    if (node.nodeType === 3) {
      var text = node.nodeValue;
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;
      var fragment = document.createDocumentFragment();
      var last = 0;
      var match;
      while ((match = pattern.exec(text)) !== null) {
        if (match.index > last) fragment.appendChild(document.createTextNode(text.slice(last, match.index)));
        var mark = document.createElement('mark');
        mark.textContent = match[0];
        fragment.appendChild(mark);
        last = match.index + match[0].length;
        if (match[0].length === 0) pattern.lastIndex++;
      }
      if (last < text.length) fragment.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(fragment, node);
      return;
    }
    if (node.nodeType !== 1 || node.nodeName === 'MARK' || node.nodeName === 'SCRIPT') return;
    var children = Array.prototype.slice.call(node.childNodes);
    for (var i = 0; i < children.length; i++) highlightNode(children[i], pattern);
  }

  function restore(record) {
    if (record.question) record.question.innerHTML = record.questionHTML;
    if (record.answer) record.answer.innerHTML = record.answerHTML;
  }

  var searchTimer = null;
  var SEARCH_DELAY = 150;

  function applySearch(rawTerm) {
    var term = (rawTerm || '').trim();
    var words = term.toLowerCase().split(/\s+/).filter(Boolean);
    var visible = 0;

    root.classList.toggle('is-searching', words.length > 0);

    records.forEach(function (record) {
      restore(record);
      var matches = words.every(function (word) {
        return record.text.indexOf(word) !== -1;
      });
      if (!words.length) {
        record.el.hidden = false;
        record.el.removeAttribute('data-sw-faq-match');
        return;
      }
      record.el.hidden = !matches;
      if (matches) {
        visible++;
        var pattern = new RegExp(words.map(escapeRegExp).join('|'), 'gi');
        if (record.question) highlightNode(record.question, pattern);
        if (record.answer) highlightNode(record.answer, pattern);
      } else if (record.el.open) {
        record.el.open = false;
      }
    });

    if (!words.length) {
      records.forEach(function (record) {
        record.el.open = false;
      });
    }

    groups.forEach(function (group) {
      var any = group.querySelector('[data-sw-faq-item]:not([hidden])');
      group.hidden = words.length > 0 && !any;
      var count = group.querySelectorAll('[data-sw-faq-item]:not([hidden])').length;
      var headCount = group.querySelector('.sw-faqp__group-head .sw-faqp__nav-count');
      if (headCount) headCount.textContent = count;
      var link = root.querySelector('[data-sw-faq-nav-link="' + group.id + '"]');
      if (link) {
        var badge = link.querySelector('[data-sw-faq-nav-count]');
        if (badge) badge.textContent = count;
        link.parentNode.hidden = words.length > 0 && count === 0;
      }
    });

    if (emptyEl) {
      emptyEl.hidden = !(words.length && visible === 0);
      if (termEl) termEl.textContent = term;
    }
    if (countEl) {
      countEl.textContent = words.length ? visible + (visible === 1 ? ' answer' : ' answers') : '';
    }
  }

  if (input) {
    input.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () {
        applySearch(input.value);
      }, SEARCH_DELAY);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        input.value = '';
        applySearch('');
      }
    });
  }
  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applySearch(input ? input.value : '');
    });
  }
  if (clearButton) {
    clearButton.addEventListener('click', function () {
      if (input) {
        input.value = '';
        input.focus();
      }
      applySearch('');
    });
  }

  /* Deep links: open and scroll to #question-slug; keep the hash in sync. */
  function openFromHash() {
    var hash = decodeURIComponent(window.location.hash || '').replace(/^#/, '');
    if (!hash) return;
    var target = document.getElementById(hash);
    if (!target) return;
    if (target.hasAttribute('data-sw-faq-item')) {
      if (input && input.value) {
        input.value = '';
        applySearch('');
      }
      target.open = true;
      if (window.SwFaqExclusive) window.SwFaqExclusive(target);
    }
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open && !root.classList.contains('is-searching') && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + item.id);
      }
    });
  });

  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  /* Scroll-spy for the category nav. */
  function setCurrent(id) {
    navLinks.forEach(function (link) {
      if (link.getAttribute('data-sw-faq-nav-link') === id) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  navLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var id = link.getAttribute('data-sw-faq-nav-link');
      var target = id && document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      setCurrent(id);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if ('IntersectionObserver' in window && groups.length) {
    var ratios = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        ratios[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0;
      });
      var best = null;
      groups.forEach(function (group) {
        if (group.hidden) return;
        if (best === null || (ratios[group.id] || 0) > (ratios[best] || 0)) best = group.id;
      });
      if (best && (ratios[best] || 0) > 0) setCurrent(best);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    groups.forEach(function (group) {
      observer.observe(group);
    });
  } else if (navLinks.length) {
    setCurrent(navLinks[0].getAttribute('data-sw-faq-nav-link'));
  }
})();
